import React from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/wa";

/**
 * WaButton - renders an *actual* <a target="_blank"> element styled like a
 * button. Real anchors bypass popup blockers + iframe sandbox restrictions
 * that synthetic .click() can't beat.
 */
export default function WaButton({
  phone,
  text,
  children,
  className = "",
  variant = "primary",
  size = "md",
  testId,
  iconOnly = false,
  title,
  onClick,
}) {
  const href = waLink(phone || "", text || "");
  const variants = {
    primary: "bg-[#25D366] hover:bg-[#1EBE5D] text-white",
    ghost: "bg-card border border-border hover:bg-muted/50 text-foreground",
    chip: "bg-[#25D366]/10 text-[#1EBE5D] hover:bg-[#25D366]/15",
  };
  const sizes = {
    xs: "text-[11px] px-2 py-1 gap-1",
    sm: "text-xs px-2.5 py-1.5 gap-1",
    md: "text-sm px-3 py-2 gap-1.5",
    lg: "text-sm font-semibold px-4 py-2.5 gap-2",
  };
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      title={title}
      onClick={(e) => { if (onClick) onClick(e); }}
      className={`inline-flex items-center font-medium rounded-md transition-colors ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${className}`}
    >
      {iconOnly ? children || <MessageCircle className="w-3.5 h-3.5" /> : children}
    </a>
  );
}
